<template>
<div>
  <div style="height: 60px;font-size: 26px;text-align: center"><strong>老年人能力评估基本信息表</strong></div>
  <el-collapse v-model="activeNames" @change="handleChange" class="grade-open">
    <el-collapse-item title="一、能力评估基本信息" name="1">
      <div style="height: 36px;line-height: 36px">老人所属区域：<span style="color: #999999">{{basic.area}}</span></div>
      <el-row>
        <el-col :span="12">
          <div style="height: 30px"></div>
        </el-col>
        <el-col :span="12">
          <div style="height: 30px"></div>
        </el-col>
      </el-row>
    </el-collapse-item>
    <el-collapse-item title="二、日常生活活动评估" name="2">
      <div style="letter-spacing: 2px">
        <span style="font-weight: bold">1. 进食(用餐具将食物由容器送到口中咀嚼、吞咽等过程 )：</span><br/>
        <el-radio-group style="padding-left:10px;" v-model="daily.eating">
          <el-radio :label="1">可独立进食(在合理的时间内独立进食准备好的食物)</el-radio>
          <el-radio :label="2">需部分帮助(进食过程中需要一定帮助，如协助把持餐具)</el-radio>
          <el-radio :label="3">需极大帮助或完全依赖他人，或有留置营养管</el-radio>
        </el-radio-group><br/>
        <span style="font-weight: bold">2.洗澡 ：</span><br/>
        <el-radio-group style="padding-left:10px;" v-model="daily.bathe">
          <el-radio :label="1">准备好洗澡水后，可自己独立完成洗澡过程</el-radio>
          <el-radio :label="2">在洗澡过程中需他人帮助</el-radio>
        </el-radio-group><br/>
      </div>
    </el-collapse-item>
    <el-collapse-item title="三、精神状态评估" name="3">
      <div>简化流程：设计简洁直观的操作流程；</div>
      <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
      <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
    </el-collapse-item>
    <el-collapse-item title="四、感知觉与沟通评估" name="4">
      <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
      <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
    </el-collapse-item>
    <el-collapse-item title="五、社会参与评估" name="5">
      <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
      <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
    </el-collapse-item>
  </el-collapse>
</div>
</template>

<script>
export default {
  name: 'evaluateAbility',
  model: {
    prop: 'gradeShow',
    event: 'change'
  },
  props: {
    gradeObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeNames: ['2'],
      basic: {
        area: '安徽-铜陵市-铜官区-东郊街道'
      },
      daily: {
        eating: '',
        bathe: ''
      }
    }
  },
  created () {
  },
  methods: {
    handleChange (val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
/deep/ .el-radio{
  display: block;
  line-height: 23px;
  white-space: normal;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/evaluateAbility.vue